<script>
// import axios from 'axios';
import Layout from '@layouts/main.vue';
import LoadingView from './_loading.vue';

export default {
  page: {
    title: 'Page timeout',
    meta: [{ name: 'description', content: 'The page timed out while loading.' }],
  },
  components: { Layout, LoadingView },
  data() {
    return {
      offlineConfirmed: false,
    };
  },
  mounted() {
    window.addEventListener('online', this.updateOnlineStatus);
    window.addEventListener('offline', this.updateOnlineStatus);
  },
  destroyed() {
    window.removeEventListener('online', this.updateOnlineStatus);
    window.removeEventListener('offline', this.updateOnlineStatus);
  },
  methods: {
    updateOnlineStatus(event) {
      if (navigator.onLine) {
        this.offlineConfirmed = false;
      } else {
        this.offlineConfirmed = true;
      }
    },
    refresh() {
      this.$router.go();
    },
  },
};
</script>

<template>
  <Layout v-if="offlineConfirmed">
    <div class="empty-state-container">
      <h2>We couldn’t find what you’re looking for.</h2>
      <p>The page timed out while loading. Are you sure you're still connected to the Internet?</p>
      <div class="actions">
        <BaseButton type="button" class="button btn-secondary btn-round" @click="refresh">
          Refresh
        </BaseButton>
      </div>
    </div>
  </Layout>
  <LoadingView v-else />
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown

.empty-state-container {
  background: white;
  border-radius: $base-border-radius-lg;
  box-shadow: 0 0.4rem 0.8rem rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  margin-bottom: 30vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 25vh;
  padding: 6rem;
  text-align: center;
  width: 55%;

  p {
    margin-top: 2rem;
  }

  .link-support {
    text-decoration: none;
  }

  .actions {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-top: 2rem;

    ::v-deep .button {
      height: 3.7rem;
      padding-bottom: 0.2rem;
      padding-top: 0.2rem;
      white-space: nowrap;
    }

    ::v-deep .button.btn-secondary {
      margin-right: 1rem;
    }
  }
}
</style>
